var exports = {
  "kL": "FormSwitch.module__container___WVVpUH",
  "oE": "FormSwitch.module__compact___WVVpUH",
  "_A": "FormSwitch.module__labelContainer___WVVpUH",
  "Pf": "FormSwitch.module__label___WVVpUH",
  "r9": "FormSwitch.module__disabled___WVVpUH",
  "vk": "FormSwitch.module__clickable___WVVpUH",
  "h_": "FormSwitch.module__description___WVVpUH",
  "HV": "FormSwitch.module__switchRoot___WVVpUH",
  "L8": "FormSwitch.module__switchThumb___WVVpUH",
  "nL": "FormSwitch.module__iconChecked___WVVpUH",
  "ao": "FormSwitch.module__iconUnchecked___WVVpUH",
};

module.exports = exports;
